<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="language_master_list" class="elevation-1 mytable" dense :search="search"
        :items-per-page="-1">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Language</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>

            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Language</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                       
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="language_super_master_list" item-text="name" return-object
                            v-model="addedItem.language_super_master_list" label="Select Language"
                            :rules="[(v) => !!v || 'required']"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.language" persistent-hint :disabled="editedIndex != -1"
                            :hint="
                              editedIndex == -1
                                ? 'For example ::Hindi, Marathi, English'
                                : 'noneditable'
                            " label="Language" :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field label="Language In Unicode" v-model="addedItem.language_super_master_list.unicode_name" v-if="editedIndex == -1"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field label="Language In Unicode " v-model="editedItem.unicode_langague" v-if="editedIndex != -1"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-text-field 
                            v-model="addedItem.google_translate_language_code" label="Google Translate Language Code"
                            :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field  v-model="editedItem.google_translate_language_code" label="Google Translate Language Code"
                            :rules="[(v) => !!v || 'required']" 
                           ></v-text-field>
                        </v-col>
                        
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-checkbox dense v-model="addedItem.is_applicable_to_google_translate" color="success" label="Is Aapplicable To Google Translate"></v-checkbox>
                      
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                           <v-checkbox dense v-model="editedItem.is_applicable_to_google_translate" color="success" label="Is Aapplicable To Google Translate"></v-checkbox>
                      
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                        
                      </v-row>
                      <v-row>
                        <v-col v-if="editedIndex == -1">
                          <v-checkbox dense v-model="newcheckbox" color="success"
                            label="Language not present in above list? Add new here..."></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && newcheckbox">
                          <v-text-field v-model="newlanguage" persistent-hint
                            hint="For example :: Hindi, Marathi, English" label="New Language"
                            ref="newlanguage"></v-text-field>
                        </v-col>
                        <v-col v-if="editedIndex == -1 && newcheckbox">
                          <v-text-field label="New Language In Unicode" v-model="new_unicode_langague"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="newcheckbox">
                          <v-btn class="mb-2 button" color="primary" small @click="saveNewLanguage">Save New
                            Language</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
         <template v-slot:item.is_applicable_to_google_translate="{ item }">
          <span v-if="item.is_applicable_to_google_translate">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      language: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
    //   { text: "Language Master", disabled: true, href: "" },

    // ],


    // breadcrumbClass: "breadcrumb-style2",
    search: "",
    dialog: false,
    language_super_master_list: null,
    newlanguage: "",
    new_unicode_langague:"",
    newcheckbox: false,
    headers: [
      {
        text: "Language",
        align: "left",
        sortable: false,
        value: "language",
      },
      {
        text: "Language In Unicode",
        align: "left",
        sortable: false,
        value: "unicode_langague",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
       {
        text: "Is Applicable To Google Translate",
        align: "left",
        sortable: true,
        value: "is_applicable_to_google_translate",
      },
       {
        text: "Google Translate Language Code",
        align: "left",
        sortable: true,
        value: "google_translate_language_code",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    language_master_list: [],
    editedIndex: -1,
    addedItem: {
      language_super_master_list: "",
    },
    editedItem: {
      id: "",
      language: "",
      unicode_langague:"",
      isactive: true,
      is_applicable_to_google_translate: false,
      google_translate_language_code: "",
    },
    defaultItem: {
      id: "",
      language: "",
      unicode_langague:"",
      isactive: true,
      is_applicable_to_google_translate: false,
      google_translate_language_code: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Language" : "Edit Language";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    //   initialize () {

    //   },
    saveNewLanguage() {
      if (this.newlanguage.length == 0) {
        this.showSnackbar("#b71c1c", "Please add Language!");
        this.$refs["newlanguage"].focus();
        return;
      }
      let data = {
        newlanguage: this.newlanguage,
        new_unicode_langague : this.new_unicode_langague

      };
      this.overlay = true;
      axios
        .post("/AdmissionMaster/addNewLanguage", data)
        .then((res) => {
          (this.newlanguage = ""),
            (this.newcheckbox = false),
            (this.overlay = false);
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Language Added Successfully!!!"); // show snackbar on success
            this.onLoad();
          } else if (res.data.status.code == "NA") {
            this.showSnackbar("#b71c1c", "Language Already Present!"); // show snackbar on error
          }
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
      this.close();
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/language")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.language_master_list = res.data.language_master_list;
              this.language_super_master_list =
                res.data.language_super_master_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.language_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.language_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_master_list.splice(index, 1)
    // },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300),
        (this.newlanguage = ""),
        (this.newcheckbox = false);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editLanguage", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                Object.assign(
                  this.language_master_list[this.editedIndex],
                  this.editedItem
                );
              }
              this.showSnackbar("#4caf50", "Language Updated Successfully..."); // show snackbar on success
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/AdmissionMaster/saveLanguage", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.language_master_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "Language Added Successfully!!!"); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              //window.alert(res.data.status.code)
              this.showSnackbar("#b71c1c", "Language Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      if (this.editedItem.language) {
        return true;
      } else {
        if (!this.editedItem.language) {
          this.errorMsg.language = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>